module.exports = __webpack_public_path__ + "static/media/pulldown_arrow.e6d98c76.svg";